/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { takeLatest, ForkEffect } from 'redux-saga/effects';
import ActionConstants from '../constants';
import workerSaga from './workerSaga';

// ------------------------------------
// Watchers
// ------------------------------------
export default function* plansWatcher(): Generator<
  ForkEffect<never>,
  void,
  unknown
> {
  yield takeLatest(ActionConstants.GET_PLANS_LIST, workerSaga);
  yield takeLatest(ActionConstants.POST_CREATE_UPDATE_PLAN, workerSaga);
  yield takeLatest(ActionConstants.DELETE_PLAN, workerSaga);
  yield takeLatest(ActionConstants.SEARCH_PLANS_BY_NAME, workerSaga);
}
